"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HELPER_TEXT_HEIGHT = void 0;
exports.HELPER_TEXT_HEIGHT = 22.4;
